<template>
  <div class="vx-card org-card">
    <!---->
    <div class="vx-card__collapsible-content vs-con-loading__container">
      <div
        class="flex justify-between flex-wrap p-6 pb-0"
        style="align-items: center"
      >
        <h3>{{title}}</h3>
        <vs-button
          class="mkplace-icon"
          color="primary"
          type="filled"
          icon="add"
          @click.stop="to()"
        ></vs-button>
      </div>
      <vs-divider/>
      <div class="vx-card__body pt-3">
        <section>
          <ul>
            <li class="flex items-start">
              <div
                class="con-vs-avatar m-0 flex-shrink-0 50px mr-3"
                style="
                  width: 50px;
                  height: 50px;
                  background: rgb(195, 195, 195);
                "
              >
                <!---->
                <div class="con-img vs-avatar--con-img">
                  <img
                    src="@/assets/images/icons/gender/default.png"
                    alt=""
                  />
                </div>
              </div>
              <div
                class="relative"
              > 
                <h4 class="mb-1">Lorem Ipsum</h4>
                <p>Lorem ipsum dolor sit amet</p>
              </div>
            </li>
            <vs-divider class="my-5"/>
            <li class="flex items-start">
              <div
                class="con-vs-avatar m-0 flex-shrink-0 50px mr-3"
                style="
                  width: 50px;
                  height: 50px;
                  background: rgb(195, 195, 195);
                "
              >
                <!---->
                <div class="con-img vs-avatar--con-img">
                  <img
                    src="@/assets/images/icons/gender/default.png"
                    alt=""
                  />
                </div>
              </div>
              <div
                class="relative"
              > 
                <h4 class="mb-1">Lorem Ipsum</h4>
                <p>Lorem ipsum dolor sit amet</p>
              </div>
            </li>
            <vs-divider class="my-5"/>
            <li class="flex items-start">
              <div
                class="con-vs-avatar m-0 flex-shrink-0 50px mr-3"
                style="
                  width: 50px;
                  height: 50px;
                  background: rgb(195, 195, 195);
                "
              >
                <!---->
                <div class="con-img vs-avatar--con-img">
                  <img
                    src="@/assets/images/icons/gender/default.png"
                    alt=""
                  />
                </div>
              </div>
              <div
                class="relative"
              > 
                <h4 class="mb-1">Lorem Ipsum</h4>
                <p>Lorem ipsum dolor sit amet</p>
              </div>
            </li>
          </ul>
        </section>
      </div>
      <!---->
    </div>
  </div>
</template>

<script>
export default {
  name: "MarketplaceCards",
  props: ["title", "dataList"],
  data() {
      return {

      }
  },
  methods: {
      to() {
          this.$router.push({name: 'org-marketplace-alex'});
      }
  }
};
</script>

<style scoped>
.mkplace-icon >>> .vs-icon {
  font-size: 2rem !important;
}
</style>